import { gql } from '@/store/helpers/axios.js'

export default {
  async GET_INTRO_DISPLAYED ({ commit }, formData) {
    const query = `query userHasIntroDisplayed {
      userHasIntroDisplayed {
          introDisplayed
      }
    }`

    const { data } = await gql({ query })

    if (!data.errors) {
      const { introDisplayed } = data.data.userHasIntroDisplayed
      commit('SET_INTRO_DISPLAYED', introDisplayed)
    }
    return data
  },
  async UPDATE_INTRO_DISPLAYED ({ state, commit }) {
      const query = `mutation userSetIntroDisplayed($introDisplayed: Boolean!) {
          userSetIntroDisplayed (introDisplayed: $introDisplayed) {
          ok
        }
      }`

    const variables = {
        introDisplayed: true
    }

    const { data } = await gql({ query, variables })
    if (!data.errors) {
       const { ok } = data.data.userSetIntroDisplayed
       commit('SET_INTRO_DISPLAYED', ok)
    }

    return data
  },
  async ACTIVATE_INTRO_SET_FALSE ({ state, commit }) {
    const query = `mutation userSetIntroDisplayed($introDisplayed: Boolean!) {
        userSetIntroDisplayed (introDisplayed: $introDisplayed) {
        ok
      }
    }`

  const variables = {
      introDisplayed: false
  }

  const { data } = await gql({ query, variables })
  if (!data.errors) {
     const { ok } = data.data.userSetIntroDisplayed
     commit('SET_INTRO_DISPLAYED', ok)
  }

  return data
}
}
